import { render, staticRenderFns } from "./RevenueAndProfit.vue?vue&type=template&id=5b560194&scoped=true"
import script from "./RevenueAndProfit.vue?vue&type=script&lang=js"
export * from "./RevenueAndProfit.vue?vue&type=script&lang=js"
import style0 from "./RevenueAndProfit.vue?vue&type=style&index=0&id=5b560194&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b560194",
  null
  
)

export default component.exports